import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/home.vue'
import Login from '@/views/login.vue'
import UserHome from '@/views/home/index.vue'
import exportBill from '@/views/export/exbill.vue'
//设置
const print = () => import('@/views/print.vue')
const bbsj = () => import('@/views/tabSz/bbsj.vue')
const xtpz = () => import('@/views/tabSz/xtpz.vue')
const bglc = () => import('@/views/tabSz/bglc.vue')
const yhbg = () => import('@/views/tabBg/yhbg.vue')
const xtsz = () => import('@/views/tabSz/xtsz.vue')
// const sqzx = () => import('@/views/tabSz/sqzx.vue')
const sqzx = () => import('@/views/tabSz/userAuth.vue')
const rzzx = () => import('@/views/tabSz/rzzx.vue')
const bzzx = () => import('@/views/tabSz/help.vue')
const sjwh = () => import('@/views/tabSz/sjwh.vue')
const xtcsh = () => import('@/views/tabSz/xtcsh.vue')
const jcmk = () => import('@/views/tabSz/PEIZHI/jcmkpeizhi.vue') // 资料弹框
const sjpz = () => import('@/views/tabSz/sjpz.vue')
//资料
const jczlCpzl = () => import('@/views/tabSz/printTemplate.vue')
const spzl = () => import('@/views/tabZl/spzl.vue')
const spzlnco = () => import('@/views/tabZl/spzlnco.vue')
const wldwnco = () => import('@/views/tabZl/wldwnco.vue')
const fzzl = () => import('@/views/tabZl/fzzl.vue')
const wldw = () => import('@/views/tabZl/wldw.vue')
const khzl = () => import('@/views/tabZl/khzl.vue')
// const khzl = () => import('@/views/tabZl/assembly/info.vue')
const gfzl = () => import('@/views/tabZl/gfzl.vue')
const bmyg = () => import('@/views/tabZl/bmyg.vue')
const ckcw = () => import('@/views/tabZl/ckcw.vue')
const zhzl = () => import('@/views/tabZl/zhzl.vue')
const splb = () => import('@/views/tabZl/splb.vue')
const wldwlb = () => import('@/views/tabZl/wldwlb.vue')
const zclb = () => import('@/views/tabZl/zclb.vue')
const srlb = () => import('@/views/tabZl/srlb.vue')
const jldw = () => import('@/views/tabZl/jldw.vue')
const jsfs = () => import('@/views/tabZl/jsfs.vue')
const khwlbm = () => import('@/views/tabZl/khwlbm.vue')
const fhdzgl = () => import('@/views/tabZl/fhdzgl.vue')
//购货
const cgdd = () => import('@/views/tabGh/cgdd.vue')
const shdcg = () => import('@/views/tabGh/shdcg.vue')
const cgddgzb = () => import('@/views/tabGh/cgddgzb.vue')
const cgmxb = () => import('@/views/tabGh/cgmxb.vue')
const cghzbsp = () => import('@/views/tabGh/cghzbsp.vue')
const cghzbgys = () => import('@/views/tabGh/cghzbgys.vue')
const cgfkylb = () => import('@/views/tabGh/cgfkylb.vue')

// 报表
const reportForms = () => import('@/components/PEIZHI/reportForms.vue')

//销货
const bjd = () => import('@/views/tabXh/bjd.vue')
const ksbj = () => import('@/views/tabXh/ksbj.vue')
const khdd = () => import('@/views/tabXh/khdd.vue')
const shdxh = () => import('@/views/tabXh/shdxh.vue')
const xsddgzb = () => import('@/views/tabXh/xsddgzb.vue')
const xsmxb = () => import('@/views/tabXh/xsmxb.vue')
const xshzbsp = () => import('@/views/tabXh/xshzbsp.vue')
const xshzbkh = () => import('@/views/tabXh/xshzbkh.vue')
const xshzbxsry = () => import('@/views/tabXh/xshzbxsry.vue')
const xsskylb = () => import('@/views/tabXh/xsskylb.vue')
const wldwqkb = () => import('@/views/tabXh/wldwqkb.vue')
//仓库
const kcdb = () => import('@/views/tabCk/kcdb.vue')
const cpfc = () => import('@/views/tabCk/cpfc.vue')
const kcpd = () => import('@/views/tabCk/kcpd.vue')
const qtrk = () => import('@/views/tabCk/qtrk.vue')
const qtck = () => import('@/views/tabCk/qtck.vue')
const bfck = () => import('@/views/tabCk/bfck.vue')
const kccx = () => import('@/views/tabCk/kccx.vue')
const zbkc = () => import('@/views/tabCk/zbkc.vue')
const spsfmxb = () => import('@/views/tabCk/spsfmxb.vue')
const spkcyeb = () => import('@/views/tabCk/spkcyeb.vue')
const spsfhzb = () => import('@/views/tabCk/spsfhzb.vue')
//资金
const fkd = () => import('@/views/tabZj/fkd.vue')
const skd = () => import('@/views/tabZj/skd.vue')
const qtsr = () => import('@/views/tabZj/qtsr.vue')
const qtzc = () => import('@/views/tabZj/qtzc.vue')
const wljz = () => import('@/views/tabZj/wljz.vue')
const qtszmxb = () => import('@/views/tabZj/qtszmxb.vue')
const yfzkmxb = () => import('@/views/tabZj/yfzkmxb.vue')
const yszkmxb = () => import('@/views/tabZj/yszkmxb.vue')
const ysdz = () => import('@/views/tabZj/ysdz.vue')
const yfdz = () => import('@/views/tabZj/yfdz.vue')

// 系统管理 的 单据、资料配置
const CD = () => import('@/views/tabSz/PEIZHI/cdpeizhi.vue') // 查单
const DJ = () => import('@/views/tabSz/PEIZHI/djpeizhi.vue') // 单据
const TJPZ = () => import('@/views/tabSz/PEIZHI/tjpeizhi.vue') // 条件配置
const ZL = () => import('@/views/tabSz/PEIZHI/zlpeizhi.vue') // 资料
const ZLTK = () => import('@/views/tabSz/PEIZHI/zltk-peizhi.vue') // 资料弹框


// 库存管理
const kcglKcpd = () => import('@/views/kcgl/kcpd.vue')
const kcglKcdb = () => import('@/views/kcgl/kcdb.vue')
const kcglQtrk = () => import('@/views/kcgl/qtrk.vue')
const kcglQtck = () => import('@/views/kcgl/qtck.vue')
const kcglBfck = () => import('@/views/kcgl/bfck.vue')

// 财务管理
const cwglYsdz = () => import('@/views/cwgl/ysdz.vue')
const cwglShd = () => import('@/views/cwgl/shd.vue')
const cwglSkd = () => import('@/views/cwgl/skd.vue')
const cwglYfdz = () => import('@/views/cwgl/yfdz.vue')
const cwglSld = () => import('@/views/cwgl/sld.vue')
const cwglFkd = () => import('@/views/cwgl/fkd.vue')
const cwglFyzc = () => import('@/views/cwgl/fyzc.vue')
const cwglQtsr = () => import('@/views/cwgl/qtsr.vue')
const cwglSzz = () => import('@/views/cwgl/szz.vue')

// 办公管理
const bgglYwdl = () => import('@/views/bggl/ywdl.vue')
const bgglQdkq = () => import('@/views/bggl/qdkq.vue')
const bgglQjsq = () => import('@/views/bggl/qjsq.vue')
const bgglBgtx = () => import('@/views/bggl/bgtx.vue')
const bgglSpsq = () => import('@/views/bggl/spsq.vue')
const bgglGrzx = () => import('@/views/bggl/grzx.vue')

// 基础资料
const jczlWldw = () => import('@/views/jczl/wldw.vue')
const jczlFzzl = () => import('@/views/jczl/fzzl.vue')
const jczlppcpk = () => import('@/views/jczl/ppcpk.vue')

// 系统管理
const xtglSqzx = () => import('@/views/xtgl/sqzx.vue')
const xtglJsgl = () => import('@/views/xtgl/jsgl.vue')
const xtglYhsp = () => import('@/views/xtgl/yhsp.vue')
const xtglSjzx = () => import('@/views/xtgl/sjzx.vue')
const xtglZlsj = () => import('@/views/xtgl/zlsj.vue')
const xtglBbsj = () => import('@/views/xtgl/bbsj.vue')
const xtglShmb = () => import('@/views/xtgl/sjmb.vue')
const xtglsjpz = () => import('@/views/xtgl/sjmb.vue')

// 系统管理 的单头、单体的表格
const xtglDBodyTable = () => import('@/views/xtgl/dBody-table.vue')
const xtglDHeadTable = () => import('@/views/xtgl/dHead-table.vue')


// 系统管理 的 单据、资料配置
// import CD from '@/views/xtgl/PEIZHI/cdpeizhi.vue'    // 查单
// import DJ from '@/views/xtgl/PEIZHI/djpeizhi.vue'    // 单据
// import TJPZ from '@/views/xtgl/PEIZHI/tjpeizhi.vue'    // 条件配置
// import ZL from '@/views/xtgl/PEIZHI/zlpeizhi.vue'      // 资料
// import ZLTK from '@/views/xtgl/PEIZHI/zltk-peizhi.vue'  // 资料弹框


Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/print',
      name: 'print',
      component: print
    },
    {
      path: '/exbill',
      name: 'exportBill',
      component: exportBill
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      children: [
        // UserHome 会被渲染在 User 的 <router-view> 中
        {
          path: '',
          component: UserHome
        }, // 默认渲染
        {
          path: 'home',
          component: UserHome
        }, // 默认渲染
        //设置
        {
          path: 'bglc',
          component: bglc,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'yhbg',
          component: yhbg,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'bbsj',
          component: bbsj,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'xtpz',
          component: xtpz,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'xtsz',
          component: xtsz,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'sqzx',
          component: sqzx,
          meta: {
            keepAlive: false
          }
        },
        {
          path: 'sjpz',
          component: sjpz,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'rzzx',
          component: rzzx,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'sjwh',
          component: sjwh,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'bzzx',
          component: bzzx,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'xtcsh',
          component: xtcsh,
          meta: {
            keepAlive: true
          }
        },
        {
          path: '9888',
          component: jcmk
        },
        //资料
        {
          path: 'spzl',
          component: spzl,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'spzlnco',
          component: spzlnco,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'wldwnco',
          component: wldwnco,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'fzzl',
          component: fzzl,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'wldw',
          component: wldw,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'khzl',
          component: khzl,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'gfzl',
          component: gfzl,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'bmyg',
          component: bmyg,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'ckcw',
          component: ckcw,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'zhzl',
          component: zhzl,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'splb',
          component: splb,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'wldwlb',
          component: wldwlb,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'zclb',
          component: zclb,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'jldw',
          component: jldw,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'jsfs',
          component: jsfs,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'srlb',
          component: srlb,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'khwlbm',
          component: khwlbm,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'fhdzgl',
          component: fhdzgl,
          meta: {
            keepAlive: true
          }
        },
        //购货
        {
          path: 'cgdd',
          component: cgdd,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'shdcg',
          component: shdcg,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'cgddgzb',
          component: cgddgzb,
          meta: {
            keepAlive: true
          }
        },
        // 报表统一路由
        {
          path: '9271',
          component: reportForms,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'cgmxb',
          component: cgmxb,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'cghzbsp',
          component: cghzbsp,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'cghzbgys',
          component: cghzbgys,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'cgfkylb',
          component: cgfkylb,
          meta: {
            keepAlive: true
          }
        },
        //购货
        {
          path: 'bjd',
          component: bjd,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'ksbj',
          component: ksbj,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'khdd',
          component: khdd,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'shdxh',
          component: shdxh,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'xsddgzb',
          component: xsddgzb,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'xsmxb',
          component: xsmxb,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'xshzbsp',
          component: xshzbsp,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'xshzbkh',
          component: xshzbkh,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'xshzbxsry',
          component: xshzbxsry,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'xsskylb',
          component: xsskylb,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'wldwqkb',
          component: wldwqkb,
          meta: {
            keepAlive: true
          }
        },
        //仓库
        {
          path: 'cpfc',
          component: cpfc,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'kcdb',
          component: kcdb,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'kcpd',
          component: kcpd,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'qtrk',
          component: qtrk,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'qtck',
          component: qtck,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'bfck',
          component: bfck,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'kccx',
          component: kccx,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'zbkc',
          component: zbkc,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'spkcyeb',
          component: spkcyeb,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'spsfmxb',
          component: spsfmxb,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'spsfhzb',
          component: spsfhzb,
          meta: {
            keepAlive: true
          }
        },
        //资金
        {
          path: 'fkd',
          component: fkd,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'skd',
          component: skd,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'qtsr',
          component: qtsr,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'qtzc',
          component: qtzc,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'yfzkmxb',
          component: yfzkmxb,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'yszkmxb',
          component: yszkmxb,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'qtszmxb',
          component: qtszmxb,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'ysdz',
          component: ysdz,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'yfdz',
          component: yfdz,
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'wljz',
          component: wljz,
          meta: {
            keepAlive: true
          }
        },

        {
          path: 'zszx',
          component: () => import('../views/bggl/zszx.vue')
        },
        {
          path: 'createEmail',
          component: () => import('../views/bggl/createEmail.vue')
        },

        { // 库存管理 库存盘点9996帮助中心
          path: '2427',
          component: kcglKcpd
        },
        { // 库存管理 库存调拨
          path: '2425',
          component: kcglKcdb
        },
        { // 库存管理 其他入库
          path: '2428',
          component: kcglQtrk
        },
        { // 库存管理 其他出库
          path: '2429',
          component: kcglQtck
        },
        { // 库存管理 报废出库
          path: '2426',
          component: kcglBfck
        },


        { // 财务管理 应收对账
          path: '2301',
          component: cwglYsdz
        },
        { // 财务管理 送货单
          path: '2311',
          component: cwglShd
        },
        { // 财务管理 收款单
          path: '2313',
          component: cwglSkd
        },
        { // 财务管理 应付对账
          path: '2302',
          component: cwglYfdz
        },
        { // 财务管理 收料单
          path: '2321',
          component: cwglSld
        },
        { // 财务管理 付款单
          path: '2323',
          component: cwglFkd
        },
        { // 财务管理 费用支出
          path: '2331',
          component: cwglFyzc
        },
        { // 财务管理 其他收入
          path: '2332',
          component: cwglQtsr
        },
        { // 财务管理 收支账
          path: '2303',
          component: cwglSzz
        },
        { // 办公管理 业务导览
          path: '1000',
          component: bgglYwdl
        },
        { // 办公管理 签到考勤
          path: '1111',
          component: bgglQdkq
        },
        { // 办公管理 请假申请
          path: '1112',
          component: bgglQjsq
        },
        { // 办公管理 办公通讯
          path: '1113',
          component: bgglBgtx
        },
        { // 办公管理 审批申请
          path: '1114',
          component: bgglSpsq
        },
        { // 办公管理 个人中心
          path: '1991',
          component: bgglGrzx
        },
        { // 基础资料 产品资料
          path: '9272',
          component: jczlCpzl
        },
        { // 数据配置
          path: '9111',
          component: xtglsjpz
        },
        { // 基础资料 往来单位
          path: '4112',
          component: jczlWldw
        },
        // {// 基础资料 部门员工
        //   path: '4113', component: jczlBmyg
        // },
        { // 基础资料 辅助资料
          path: '6199',
          component: jczlFzzl
        },
        { // 基础资料 品牌产品库
          path: '4120',
          component: jczlppcpk
        },
        { // 系统管理 授权中心
          path: '9111',
          component: xtglSqzx
        },
        { // 系统管理 角色管理
          path: '9112',
          component: xtglJsgl
        },
        { // 系统管理 用户审批
          path: '9121',
          component: xtglYhsp
        },
        { // 系统管理 数据中心
          path: '9312',
          component: xtglSjzx
        },
        { // 系统管理 设计模板
          path: '9115',
          component: xtglShmb
        },
        { // 系统管理 资料设计
          path: '9113',
          component: xtglZlsj
        },
        { // 系统管理 报表设计
          path: '9114',
          component: xtglBbsj
        },
        { // 系统管理 单头表格
          path: 'h1010',
          component: xtglDHeadTable
        },
        { // 系统管理 单体表格
          path: 'b1011',
          component: xtglDBodyTable
        },
        { // 系统管理 查单配置
          path: '9116',
          component: CD
        },
        { // 系统管理 单据配置
          path: '9117',
          component: DJ
        },
        { // 系统管理 条件查询配置
          path: '9118',
          component: TJPZ
        },
        { // 系统管理 资料配置
          path: '9119',
          component: ZL
        },
        { // 系统管理 资料弹框配置
          path: '9120',
          component: ZLTK
        },
      ]
    },
  ]
})
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js